// Generated by ts-to-zod
import { z } from 'zod';

export const relatedObjectsCountsSchema = z.object({
  emails: z.number(),
  annotations: z.number(),
  trainedDedicatedEngines: z.number(),
});
